module.exports = __webpack_public_path__ + "img/行程单示例.0c1b6de0.png";